import React__default from 'react';
import { NvTabPanel } from '../NvTabPanel/NvTabPanel.esm.js';
import { useTabs } from '../NvTabs.hooks.esm.js';

var NvTab = function (_a) {
    var children = _a.children, tabId = _a.tabId, disabled = _a.disabled;
    var isCurrentTab = useTabs().isCurrentTab;
    if (disabled)
        return null;
    return (React__default.createElement(NvTabPanel, { show: isCurrentTab(tabId), tabId: tabId }, children));
};
var NvTab$1 = Object.assign(NvTab, {
    Panel: NvTabPanel,
});

export { NvTab$1 as default };
//# sourceMappingURL=NvTab.esm.js.map
